import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {CampaignPreviewState} from './campaignPreview.types';

const campaignPreviewInitialState: CampaignPreviewState = {
  previewParams: {},
  previewMeta: null,
  previewSteps: [],
  numOfPreviewSteps: 0,
  highlightedNodeId: NO_NODE_ID,
};

export {campaignPreviewInitialState};
